var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeadlinePage",class:[
    {
      'HeadlinePage--disabled': _vm.title === 'Meus pedidos',
      'HeadlinePage--active': _vm.shipping,
    },
  ]},[_c('div',{staticClass:"flex items-center gap-4"},[(_vm.backpage)?_c('imgBack',{staticClass:"cursor-pointer",attrs:{"alt":"Voltar"},on:{"click":_vm.back}}):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))])],1),(_vm.shipping)?_c('Badge',{staticClass:"ml-auto mr-4 lg:mr-0",attrs:{"id":"done-1","variant":"done"}},[_vm._v(" Frete incluso ")]):_vm._e(),_c('IconHamburger',{attrs:{"id":"ico-hamburger"}}),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }